/**
 * Entrada do bundle IIFE (`widget.js`) — o arquivo que vai na tag `<script>` do site do cliente.
 * Só faz uma coisa: autoexecutar o bootstrap, com trava contra inclusão dupla (acontece bastante
 * quando o snippet é colado no GTM *e* no HTML).
 */

import { bootstrap } from './bootstrap.js';

declare global {
  interface Window {
    __merlinWebchatLoaded?: boolean;
  }
}

if (window.__merlinWebchatLoaded) {
  console.warn('[merlin-webchat] o widget já foi carregado nesta página; ignorando a segunda inclusão.');
} else {
  window.__merlinWebchatLoaded = true;
  void bootstrap().catch((error: unknown) => {
    console.error('[merlin-webchat] falha ao inicializar:', error);
  });
}
